import React from "react";

import { resolveColor } from "utils/commonFunctions";

interface Props {
    size?: number;
    color?: string;
}

export const DragAndDrop = (props: Props) => {
    return (
        <svg
            width={props.size ?? 24}
            height={props.size ?? 24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M15 5.99951L11.9986 3L9.00005 5.99951M11.9986 3L12 21.001M15 18L11.9984 21L9.00005 18M18 9L21 11.9998L18 15M2.99902 12L20.9965 11.9989M6.00004 15.0002L3.00093 12.001L6.00009 9.00011"
                fill={props.color ?? resolveColor("--theme-icon-fill-default")}
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.4682 2.46975C11.761 2.17685 12.2359 2.17674 12.5288 2.4695L15.5302 5.46901C15.8232 5.76182 15.8233 6.23669 15.5305 6.52967C15.2377 6.82266 14.7629 6.82281 14.4699 6.53001L12.7488 4.80999L12.7493 11.2494L19.1885 11.249L17.4697 9.53034C17.1768 9.23746 17.1768 8.76259 17.4697 8.46968C17.7626 8.17678 18.2375 8.17677 18.5304 8.46966L21.5304 11.4695C21.671 11.6101 21.75 11.8009 21.75 11.9998C21.7501 12.1987 21.671 12.3895 21.5304 12.5302L18.5304 15.5303C18.2375 15.8232 17.7626 15.8232 17.4697 15.5303C17.1768 15.2375 17.1768 14.7626 17.4697 14.4697L19.1903 12.749L12.7494 12.7494L12.7498 19.1886L14.4699 17.4695C14.7628 17.1767 15.2377 17.1768 15.5305 17.4698C15.8233 17.7628 15.8232 18.2377 15.5302 18.5305L12.5656 21.4935C12.4281 21.6513 12.2257 21.751 12 21.751C11.843 21.751 11.6972 21.7027 11.5767 21.6202C11.538 21.5939 11.5015 21.5638 11.4679 21.5302L8.46957 18.5302C8.17676 18.2372 8.17689 17.7623 8.46986 17.4695C8.76283 17.1767 9.23771 17.1768 9.53052 17.4698L11.2498 19.1901L11.2494 12.7495L4.81045 12.7499L6.53037 14.4698C6.82326 14.7627 6.82326 15.2376 6.53037 15.5305C6.23748 15.8234 5.7626 15.8234 5.46971 15.5305L2.49079 12.5516C2.34215 12.4145 2.24904 12.2182 2.24902 12.0001C2.24901 11.7729 2.34997 11.5694 2.50948 11.4318L5.4696 8.46994C5.76241 8.17696 6.23728 8.17682 6.53026 8.46963C6.82324 8.76243 6.82338 9.23731 6.53058 9.53029L4.81197 11.2499L11.2493 11.2495L11.2488 4.81092L9.53046 6.52976C9.23761 6.8227 8.76273 6.82277 8.4698 6.52992C8.17686 6.23707 8.17679 5.7622 8.46963 5.46926L11.4682 2.46975Z"
                fill={props.color ?? resolveColor("--theme-icon-fill-default")}
            />
        </svg>
    );
};
